<template>
  <div class="home">
    <!-- <v-header @changeTab="changTab"></v-header> -->
    <div class="backend-div">
    <v-sidebar v-bind:class="{'sidebar' : isShow,'hideSidebar':isHide}"></v-sidebar>
    <div v-bind:class="{'mains':isShow,'hideMains':isHide}" :style="fullHeight" >
      <keep-alive>
        <router-view/>
      </keep-alive>

    </div>
    </div>
  </div>
</template>

<script>
/*
   * 导入
   * 头部、
   * footer、
   * 面包屑
   * 模块
   * */
import vHeader from '@/layout/BackendHeader.vue'
import vSidebar from '@/layout/BackendSidebar.vue'
//  import vFooter from "@/components/manage/layout/Footer.vue"
//  import vCrumbnav from "@/layout/Crumbnav.vue"

export default {
//        组件名称
  name: 'backendHome',
  //        导入相关模块
  components: {vHeader, vSidebar},
  //        初始化变量
  data () {
    /// /            返回值
    return {
      //                初始化高度，后期可变
      fullHeight: {height: ''},
      //                默认显示
      isShow: true,
      //                默认隐藏
      isHide: false }
  },
  //        页面加载完渲染
  created () {
    /// /            this.changTab()
    /// /            获取高度
    this.height()
    //    },
    /// /        一直在执行
    //    updated(){ this.height()
  },
  methods: {
    //            判断跳转路径
    changTab (v) {
      if (v === 'system') { this.$router.push({path: '/manage/system'}) } else {
        this.$router.push({path: '/manage/page_model'})
      }
    },
    //            获取高度
    height () { this.fullHeight.height = window.innerHeight - 20 + 'px' }
    //            控制隐藏和显示

  },
  mounted () {
    /// /            获取浏览器改变是高度
    const that = this
    //            浏览器方法
    window.onresize = () => {
      //                返回值
      return (() => {
        window.fullHeight = document.documentElement.clientHeight
        that.fullHeight.height = window.fullHeight
      })()
    }
  },
  //        监视屏幕大小改变
  watch: {
    fullHeight (val) {
      if (!this.timer) {
        this.fullHeight = val
        //                    一直在执行
        this.timer = true
        let that = this
        //                    400毫秒执行依稀
        setTimeout(function () { that.timer = false }, 400)
      }
    }
  }
}
</script>

<style scoped>
  body{
    margin:0;
  }
  .mains{
    margin-left:17%;
    overflow: auto;
    padding:0 1%
  }

  /* @media screen and (min-width: 1400px) {
     .mains{
      margin-left:10%;
      overflow: auto;
    }
  } */
  .backend-div{
    background-color:#F5F6FA;
    padding-top: 20px
  }
</style>



// WEBPACK FOOTER //
// src/pages/backendHome.vue